<template>
  <div>
    <AppHeader
      ref="app-header-video-package"
      v-bind="headerProps"
      :has-category="false"
      @updateOffsetTopWindows="updateOffsetTopWindows"
      @updateDisplayNavbar="updateDisplayNavbar"
    >
      <template #search-box="{show}">
        <SearchBoxMobileHeader
          v-if="show"
          @emitCloseSearchBox="closeSearchBox"
        />
      </template>
    </AppHeader>
    <Nuxt />
    <AppFooter v-bind="footerProps" />
    <CallButton
      v-if="!$store.state.hiddenBtnCall"
      :ostadbank-support-phone="headerProps.ostadbankSupportPhone"
    />
  </div>
</template>
<script>
import { hydrateWhenVisible } from 'vue-lazy-hydration'
import AppHeader from '@design-system/ui/header'
import CallButton from '@design-system/ui/call-button'
import connectionCheck from '@mixins/connection-check'
import SearchBoxMobileHeader from '@design-system/layouts/search-box-mobile-header'

export default {
  name: 'Default',
  components: {
    SearchBoxMobileHeader,
    AppFooter: hydrateWhenVisible(() => import('@design-system/ui/footer'), {
      observerOptions: { rootMargin: '70px' }
    }),
    AppHeader,
    CallButton
  },
  mixins: [connectionCheck],

  computed: {
    footerProps () {
      return {
        ostadbankSupportPhone:
          this.$store.state.settings.ostadbank_support_phone.code +
          this.$store.state.settings.ostadbank_support_phone.number,
        linkCol1: [
          {
            tag: 'a',
            text: this.$t('footer.menus.about_us'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.about_us)
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.menus.contact_us'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.contact_us)
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.menus.faq'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.faq),
              class: 'faqClick'
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.menus.mag'),
            attrTag: {
              href: this.$config.app_mag_base_url,
              class: 'headerMagClick',
              target: '_blank',
              rel: 'follow'
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.menus.rule'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.policies)
            }
          }
        ],
        linkCol2: [
          {
            tag: 'a',
            text: this.$t('footer.links.join_teacher'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_start_teaching_base_url, this.$routeName.start_teaching),
              class: 'startTeachingClick'
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.menus.edu'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_edu_base_url, ''),
              class: 'eduClick',
              rel: 'follow'
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.links.join_academy'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_academy_base_url, ''),
              class: 'academyClick',
              rel: 'follow'
            }
          },
          {
            tag: 'a',
            text: this.$t('footer.links.schools'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_school_base_url, this.$routeName.schools_list)
            }
          }
        ],
        socials: [
          { name: 'linkedin', link: 'https://www.linkedin.com/company/ostadbank' },
          { name: 'telegram', link: 'https://t.me/ostadbank_channel' },
          { name: 'instagram', link: 'https://www.instagram.com/ostadbank_official/' }
        ]
      }
    },
    headerProps () {
      return {
        isTransparent: true,
        spaceClass: '__forum',
        auth: this.$auth,
        ostadbankSupportPhone:
          this.$store.state.settings.ostadbank_support_phone.code +
          this.$store.state.settings.ostadbank_support_phone.number,
        linksHeaderTop: {
          home: {
            tag: 'a',
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.home)
            }
          },
          adminPanel: {
            tag: 'a',
            text: this.$t('menu.admin'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.admin_panel)
            }
          },
          startTeaching: {
            tag: 'a',
            text: this.$t('menu.register_teacher'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_start_teaching_base_url, this.$routeName.start_teaching),
              class: 'startTeachingClick'
            }
          },
          dashboardTeacher: {
            tag: 'a',
            text: this.$t('menu.dashboard_teacher'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard_teacher),
              class: 'startTeachingClick'
            }
          },
          login: {
            tag: 'a',
            text: this.$t('menu.login'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.login),
              class: 'profileSignUp'
            }
          },
          logout: {
            tag: 'a',
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.logout)
            }
          },
          linkTopDesktop: [
            {
              tag: 'a',
              attrTag: {
                href: this.$config.app_mag_base_url,
                class: 'headerMagClick'
              },
              text: this.$t('menu.header_top.mag')
            },
            {
              tag: 'a',
              attrTag: {
                href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.faq),
                class: 'faqClick'
              },
              text: this.$t('menu.header_top.faq')
            }
          ],
          linkSidebarMobile: this.menuSidebarMobile,
          avatarList: [
            {
              component: 'AvatarUserItem',
              text: this.$t('user_avatar.dashboard'),
              icon: {
                name: 'view-dashboard-outline',
                viewBox: '0 0 12 12',
                size: 'tiny'
              },
              tagLink: {
                tag: 'a',
                attrTag: {
                  href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard)
                }
              }
            },
            {
              component: 'AvatarUserWallet',
              text: this.$t('user_avatar.wallet'),
              icon: {
                name: 'account-wallet',
                viewBox: '0 0 24 24',
                size: 'small'
              },
              tagLink: {
                tag: 'a',
                attrTag: {
                  href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard_wallet)
                }
              }
            },
            {
              component: 'AvatarUserItem',
              text: this.$t('user_avatar.request'),
              icon: {
                name: 'text-box-check-outline',
                viewBox: '0 0 24 24',
                size: 'small'
              },
              tagLink: {
                tag: 'a',
                attrTag: {
                  href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard_my_requests)
                }
              }
            },
            {
              component: 'AvatarUserItem',
              text: this.$t('user_avatar.exit'),
              icon: {
                name: 'exit',
                viewBox: '0 0 24 24',
                size: 'small'
              },
              tagLink: {
                tag: 'a',
                attrTag: {
                  href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.logout)
                }
              }
            }
          ]
        }
      }
    },
    menuSidebarMobile () {
      const menus = [
        {
          order: 2,
          tag: 'a',
          icon: 'home',
          text: this.$t('menu.header_top.home'),
          attrTag: {
            href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.home)
          }
        },
        {
          order: 4,
          tag: 'a',
          icon: 'mag',
          text: this.$t('menu.header_top.mag'),
          attrTag: {
            href: this.$config.app_mag_base_url
          }
        }
      ]
      if (this.$auth.loggedIn) {
        menus.push({
          order: 1,
          tag: 'a',
          icon: 'view-dashboard',
          divider: true,
          text: this.$t('user_avatar.dashboard'),
          attrTag: {
            href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard)
          }
        })
        if (this.$auth.user.role === 'teacher') {
          if (this.$auth.user.teacher.status === 'approved') {
            menus.push({
              order: 6,
              tag: 'a',
              icon: 'human-male-board',
              text: this.$t('menu.dashboard_teacher'),
              attrTag: {
                href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.dashboard_teacher)
              }
            })
          } else {
            menus.push({
              order: 3,
              tag: 'a',
              icon: 'human-male-board',
              text: this.$t('menu.register_teacher'),
              attrTag: {
                href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.start_teaching),
                class: 'startTeachingClick'
              }
            })
          }
        }
        if (this.$auth.user.role === 'admin') {
          menus.push({
            order: 7,
            tag: 'a',
            icon: 'human-male-board',
            text: this.$t('menu.admin'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.admin_panel),
              class: 'startTeachingClick'
            }
          })
        }
        if (this.$auth.user.role === 'user') {
          menus.push({
            order: 3,
            tag: 'a',
            icon: 'human-male-board',
            text: this.$t('menu.register_teacher'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_start_teaching_base_url, this.$routeName.start_teaching),
              class: 'startTeachingClick'
            }
          })
          menus.push({
            order: 7,
            tag: 'a',
            icon: 'faq',
            divider: true,
            text: this.$t('menu.header_top.faq'),
            attrTag: {
              href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.faq)
            }
          })
        }
      } else {
        menus.push({
          order: 3,
          tag: 'a',
          icon: 'human-male-board',
          text: this.$t('menu.register_teacher'),
          attrTag: {
            href: this.$routeName.sub_absolute_link(this.$config.app_start_teaching_base_url, this.$routeName.start_teaching),

            class: 'startTeachingClick'
          }
        })
        menus.push({
          order: 7,
          tag: 'a',
          icon: 'faq',
          text: this.$t('menu.header_top.faq'),
          attrTag: {
            href: this.$routeName.sub_absolute_link(this.$config.app_main_base_url, this.$routeName.faq)
          }
        })
      }
      return menus.sort((a, b) => (a.order > b.order ? 1 : -1))
    }
  },
  mounted () {
    this.clearStorage()
  },
  methods: {
    closeSearchBox () {
      this.$refs['app-header-video-package'].closeSearchBox()
    },
    clearStorage () {
      if (!process.client) {
        console.log('clearStorage Layout Default !process.client')
        return
      }
      this.clearMobile()
      this.clearRedirect()
    },
    clearRedirect () {
      try {
        if (this.$auth) {
          if (this.$auth.$storage) {
            if (this.$auth.$storage.getUniversal('redirect_url')) {
              this.$auth.$storage.removeUniversal('redirect_url')
            }
          }
        }
      } catch (e) {
        console.log('clearStorage redirect_url Layout Default')
        this.$logger.captureException({ error: e })
      }
    },
    clearMobile () {
      try {
        if (this.$config.mobile) {
          if (this.$auth.$storage.getUniversal(this.$config.mobile)) {
            this.$auth.$storage.removeUniversal(this.$config.mobile)
          }
        }
      } catch (e) {
        console.log('clearStorage mobile Layout Default')
        this.$logger.captureException({ error: e })
      }
    },
    updateOffsetTopWindows () {
      this.closeSearchBox()
      this.$store.commit('SET_OFFSET_TOP_WINDOWS', window.pageYOffset)
    },
    updateDisplayNavbar () {
      this.closeSearchBox()
      this.$store.commit('SET_DISPLAY_NAVBAR', this.showNavbar)
    }
  }
}
</script>
